import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Paper,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import ForecastTrendChart from "../ForecastTrendChart";

const ForecastTrendPaper = ({
  classes,
  paperTitle,
  forecastTrendData,
  isForecastTrendLoading,
  handleForecastTrendDrilldown,
  currencySymbol,
}) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <div className={classes.header}>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="h5" className={classes.title}>
              {forecastTrendData?.title || "Forecast Trend"} ({currencySymbol}M)
            </Typography>
            <span className={classes.updateFrequency}>{"Live Data"}</span>
          </Box>
        </div>

        {/* Quarterly Charts - 2x2 Grid with Loading */}
        {isForecastTrendLoading ? (
          <Grid container spacing={3}>
            {[1, 2, 3, 4].map((index) => (
              <Grid item xs={12} sm={6} md={6} lg={6} key={index}>
                <Card className={classes.chartCard}>
                  <CardContent>
                    <Skeleton
                      variant="rect"
                      animation="wave"
                      height={300}
                      width="100%"
                    />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid container spacing={3}>
            {forecastTrendData?.quarters?.map((quarter) => (
              <Grid item xs={12} sm={6} md={6} lg={6} key={quarter.quarter}>
                <Card className={classes.chartCard}>
                  <CardContent>
                    <div className={classes.chartContainer}>
                      <ForecastTrendChart
                        data={quarter.weeklyData}
                        quarterLabel={quarter.quarter}
                        quarter={quarter.quarter}
                        status={quarter.status}
                        target={quarter.target}
                        onDrill={handleForecastTrendDrilldown}
                      />
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        {/* Legend */}
        <Box mt={3}>
          <div className={classes.legend}>
            <div className={classes.legendItem}>
              <div
                className={classes.legendBox}
                style={{ backgroundColor: "#70ad47" }}
              />
              <Typography variant="body2">Won</Typography>
            </div>
            <div className={classes.legendItem}>
              <div
                className={classes.legendBox}
                style={{ backgroundColor: "#c5e0b4" }}
              />
              <Typography variant="body2">Most Likely + Commit</Typography>
            </div>
            <div className={classes.legendItem}>
              <div
                className={classes.legendBox}
                style={{ backgroundColor: "#bf9000", height: 3, width: 24 }}
              />
              <Typography variant="body2">Target</Typography>
            </div>
          </div>
        </Box>
      </Paper>
    </Grid>
  );
};

export default ForecastTrendPaper;
